import { render, staticRenderFns } from "./RicercaFatture.vue?vue&type=template&id=bc0edc1a&scoped=true&"
import script from "./RicercaFatture.vue?vue&type=script&lang=js&"
export * from "./RicercaFatture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0edc1a",
  null
  
)

export default component.exports